/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Noserverconnection2Inputs */

const en_noserverconnection2 = /** @type {(inputs: Noserverconnection2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No connection to server. Please check your internet connection.`)
};

const de_noserverconnection2 = /** @type {(inputs: Noserverconnection2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Verbindung zum Server. Prüf deine Internetverbindung.`)
};

/**
* | output |
* | --- |
* | "No connection to server. Please check your internet connection." |
*
* @param {Noserverconnection2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const noserverconnection2 = /** @type {((inputs?: Noserverconnection2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Noserverconnection2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_noserverconnection2(inputs)
	return de_noserverconnection2(inputs)
});
export { noserverconnection2 as "noServerConnection" }